import { takeLeading, takeEvery } from 'redux-saga/effects';
import * as types from '../../actions/db/types';

import {
    getCertificadosPolizaSaga, getCertificadoPolizaSaga, postCertificadoPolizaSaga, putCertificadoPolizaSaga, deleteCertificadoPolizaSaga,       getPolizasSaga, getPolizaSaga, postPolizaSaga, putPolizaSaga, deletePolizaSaga,       getProductosPolizaSaga, getProductoPolizaSaga, postProductoPolizaSaga, putProductoPolizaSaga, deleteProductoPolizaSaga,       getDPsProductoPolizaSaga, getDPProductoPolizaSaga, postDPProductoPolizaSaga, putDPProductoPolizaSaga, deleteDPProductoPolizaSaga,       getAseguradosCertificadoPolizaSaga, getAseguradoCertificadoPolizaSaga, postAseguradoCertificadoPolizaSaga, putAseguradoCertificadoPolizaSaga, deleteAseguradoCertificadoPolizaSaga,       getTelsCertificadoPolizaSaga, getTelCertificadoPolizaSaga, postTelCertificadoPolizaSaga, putTelCertificadoPolizaSaga, deleteTelCertificadoPolizaSaga,       getArchivosCertificadoPolizaSaga, getArchivoCertificadoPolizaSaga, postArchivoCertificadoPolizaSaga, putArchivoCertificadoPolizaSaga, deleteArchivoCertificadoPolizaSaga,       getDPsCertificadoPolizaSaga, getDPCertificadoPolizaSaga, postDPCertificadoPolizaSaga, putDPCertificadoPolizaSaga, deleteDPCertificadoPolizaSaga,       getPagosOxxoSaga, getPagoOxxoSaga, postPagoOxxoSaga, putPagoOxxoSaga, deletePagoOxxoSaga,       getRegistrosPagoOxxoSaga, getRegistroPagoOxxoSaga, postRegistroPagoOxxoSaga, putRegistroPagoOxxoSaga, deleteRegistroPagoOxxoSaga,       getEndososCertificadoPolizaSaga, getEndosoCertificadoPolizaSaga, postEndosoCertificadoPolizaSaga, putEndosoCertificadoPolizaSaga, deleteEndosoCertificadoPolizaSaga,       getBenefsCertificadoPolizaSaga, getBenefCertificadoPolizaSaga, postBenefCertificadoPolizaSaga, putBenefCertificadoPolizaSaga, deleteBenefCertificadoPolizaSaga,       getFacturasAgenteSaga, getFacturaAgenteSaga, postFacturaAgenteSaga, putFacturaAgenteSaga, deleteFacturaAgenteSaga,       getPrimasProductoPolizaSaga, getPrimaProductoPolizaSaga, postPrimaProductoPolizaSaga, putPrimaProductoPolizaSaga, deletePrimaProductoPolizaSaga,       getAseguradorasSaga, getAseguradoraSaga, postAseguradoraSaga, putAseguradoraSaga, deleteAseguradoraSaga,       getProductosSaga, getProductoSaga, postProductoSaga, putProductoSaga, deleteProductoSaga,       getAgentesSaga, getAgenteSaga, postAgenteSaga, putAgenteSaga, deleteAgenteSaga,       getDetallesListaDePrecioSaga, getDetalleListaDePrecioSaga, postDetalleListaDePrecioSaga, putDetalleListaDePrecioSaga, deleteDetalleListaDePrecioSaga,       getAseguradosProductoSaga, getAseguradoProductoSaga, postAseguradoProductoSaga, putAseguradoProductoSaga, deleteAseguradoProductoSaga,       getListasDePrecioSaga, getListaDePrecioSaga, postListaDePrecioSaga, putListaDePrecioSaga, deleteListaDePrecioSaga,       getPrimasListaDePrecioSaga, getPrimaListaDePrecioSaga, postPrimaListaDePrecioSaga, putPrimaListaDePrecioSaga, deletePrimaListaDePrecioSaga,       getCoberturasProductoSaga, getCoberturaProductoSaga, postCoberturaProductoSaga, putCoberturaProductoSaga, deleteCoberturaProductoSaga,       getClavesComisionSaga, getClaveComisionSaga, postClaveComisionSaga, putClaveComisionSaga, deleteClaveComisionSaga,       getProductosClaveComisionSaga, getProductoClaveComisionSaga, postProductoClaveComisionSaga, putProductoClaveComisionSaga, deleteProductoClaveComisionSaga,       getFormasPagoSaga, getFormaPagoSaga, postFormaPagoSaga, putFormaPagoSaga, deleteFormaPagoSaga,       getParentezcosSaga, getParentezcoSaga, postParentezcoSaga, putParentezcoSaga, deleteParentezcoSaga,       getEstatusPagosSaga, getEstatusPagoSaga, postEstatusPagoSaga, putEstatusPagoSaga, deleteEstatusPagoSaga,       getTiposProductoSaga, getTipoProductoSaga, postTipoProductoSaga, putTipoProductoSaga, deleteTipoProductoSaga,       getOrigenesSaga, getOrigenSaga, postOrigenSaga, putOrigenSaga, deleteOrigenSaga,       getGenerosSaga, getGeneroSaga, postGeneroSaga, putGeneroSaga, deleteGeneroSaga,       getEstatusCertificadosSaga, getEstatusCertificadoSaga, postEstatusCertificadoSaga, putEstatusCertificadoSaga, deleteEstatusCertificadoSaga,       getEstatusPolizasSaga, getEstatusPolizaSaga, postEstatusPolizaSaga, putEstatusPolizaSaga, deleteEstatusPolizaSaga,       getMediosPagoSaga, getMedioPagoSaga, postMedioPagoSaga, putMedioPagoSaga, deleteMedioPagoSaga,       getEstatusRegistrosPagoOxxoSaga, getEstatusRegistroPagoOxxoSaga, postEstatusRegistroPagoOxxoSaga, putEstatusRegistroPagoOxxoSaga, deleteEstatusRegistroPagoOxxoSaga,       getMotivosCancelacionSaga, getMotivoCancelacionSaga, postMotivoCancelacionSaga, putMotivoCancelacionSaga, deleteMotivoCancelacionSaga,       getRegimenesFiscalesSaga, getRegimenFiscalSaga, postRegimenFiscalSaga, putRegimenFiscalSaga, deleteRegimenFiscalSaga,       getUsuariosSaga, getUsuarioSaga, postUsuarioSaga, putUsuarioSaga, deleteUsuarioSaga,       getActualizacionesSaga, getActualizacionSaga, postActualizacionSaga, putActualizacionSaga, deleteActualizacionSaga,       getOperacionesSaga, getOperacionSaga, postOperacionSaga, putOperacionSaga, deleteOperacionSaga,       getRutasSaga, getRutaSaga, postRutaSaga, putRutaSaga, deleteRutaSaga,       getPerfilesSaga, getPerfilSaga, postPerfilSaga, putPerfilSaga, deletePerfilSaga,       getRutasRolSaga, getRutaRolSaga, postRutaRolSaga, putRutaRolSaga, deleteRutaRolSaga,       getRolesSaga, getRolSaga, postRolSaga, putRolSaga, deleteRolSaga,       getRolesPerfilSaga, getRolPerfilSaga, postRolPerfilSaga, putRolPerfilSaga, deleteRolPerfilSaga, } from './dbsaga';

export default function* watchUserAuthentication() {

  yield takeLeading (types.GET_CERTIFICADOSPOLIZA, getCertificadosPolizaSaga); 
  yield takeLeading (types.GET_CERTIFICADOPOLIZA, getCertificadoPolizaSaga);
  yield takeLeading (types.POST_CERTIFICADOPOLIZA, postCertificadoPolizaSaga);
  yield takeLeading (types.PUT_CERTIFICADOPOLIZA, putCertificadoPolizaSaga);
  yield takeLeading (types.DELETE_CERTIFICADOPOLIZA, deleteCertificadoPolizaSaga);

  yield takeEvery(types.GET_EVERY_CERTIFICADOSPOLIZA, getCertificadosPolizaSaga);
  yield takeEvery(types.GET_EVERY_CERTIFICADOPOLIZA, getCertificadoPolizaSaga);
  yield takeEvery(types.POST_EVERY_CERTIFICADOPOLIZA, postCertificadoPolizaSaga);
  yield takeEvery(types.PUT_EVERY_CERTIFICADOPOLIZA, putCertificadoPolizaSaga);
  yield takeEvery(types.DELETE_EVERY_CERTIFICADOPOLIZA, deleteCertificadoPolizaSaga);

  yield takeLeading (types.GET_POLIZAS, getPolizasSaga); 
  yield takeLeading (types.GET_POLIZA, getPolizaSaga);
  yield takeLeading (types.POST_POLIZA, postPolizaSaga);
  yield takeLeading (types.PUT_POLIZA, putPolizaSaga);
  yield takeLeading (types.DELETE_POLIZA, deletePolizaSaga);

  yield takeEvery(types.GET_EVERY_POLIZAS, getPolizasSaga);
  yield takeEvery(types.GET_EVERY_POLIZA, getPolizaSaga);
  yield takeEvery(types.POST_EVERY_POLIZA, postPolizaSaga);
  yield takeEvery(types.PUT_EVERY_POLIZA, putPolizaSaga);
  yield takeEvery(types.DELETE_EVERY_POLIZA, deletePolizaSaga);

  yield takeLeading (types.GET_PRODUCTOSPOLIZA, getProductosPolizaSaga); 
  yield takeLeading (types.GET_PRODUCTOPOLIZA, getProductoPolizaSaga);
  yield takeLeading (types.POST_PRODUCTOPOLIZA, postProductoPolizaSaga);
  yield takeLeading (types.PUT_PRODUCTOPOLIZA, putProductoPolizaSaga);
  yield takeLeading (types.DELETE_PRODUCTOPOLIZA, deleteProductoPolizaSaga);

  yield takeEvery(types.GET_EVERY_PRODUCTOSPOLIZA, getProductosPolizaSaga);
  yield takeEvery(types.GET_EVERY_PRODUCTOPOLIZA, getProductoPolizaSaga);
  yield takeEvery(types.POST_EVERY_PRODUCTOPOLIZA, postProductoPolizaSaga);
  yield takeEvery(types.PUT_EVERY_PRODUCTOPOLIZA, putProductoPolizaSaga);
  yield takeEvery(types.DELETE_EVERY_PRODUCTOPOLIZA, deleteProductoPolizaSaga);

  yield takeLeading (types.GET_DPSPRODUCTOPOLIZA, getDPsProductoPolizaSaga); 
  yield takeLeading (types.GET_DPPRODUCTOPOLIZA, getDPProductoPolizaSaga);
  yield takeLeading (types.POST_DPPRODUCTOPOLIZA, postDPProductoPolizaSaga);
  yield takeLeading (types.PUT_DPPRODUCTOPOLIZA, putDPProductoPolizaSaga);
  yield takeLeading (types.DELETE_DPPRODUCTOPOLIZA, deleteDPProductoPolizaSaga);

  yield takeEvery(types.GET_EVERY_DPSPRODUCTOPOLIZA, getDPsProductoPolizaSaga);
  yield takeEvery(types.GET_EVERY_DPPRODUCTOPOLIZA, getDPProductoPolizaSaga);
  yield takeEvery(types.POST_EVERY_DPPRODUCTOPOLIZA, postDPProductoPolizaSaga);
  yield takeEvery(types.PUT_EVERY_DPPRODUCTOPOLIZA, putDPProductoPolizaSaga);
  yield takeEvery(types.DELETE_EVERY_DPPRODUCTOPOLIZA, deleteDPProductoPolizaSaga);

  yield takeLeading (types.GET_ASEGURADOSCERTIFICADOPOLIZA, getAseguradosCertificadoPolizaSaga); 
  yield takeLeading (types.GET_ASEGURADOCERTIFICADOPOLIZA, getAseguradoCertificadoPolizaSaga);
  yield takeLeading (types.POST_ASEGURADOCERTIFICADOPOLIZA, postAseguradoCertificadoPolizaSaga);
  yield takeLeading (types.PUT_ASEGURADOCERTIFICADOPOLIZA, putAseguradoCertificadoPolizaSaga);
  yield takeLeading (types.DELETE_ASEGURADOCERTIFICADOPOLIZA, deleteAseguradoCertificadoPolizaSaga);

  yield takeEvery(types.GET_EVERY_ASEGURADOSCERTIFICADOPOLIZA, getAseguradosCertificadoPolizaSaga);
  yield takeEvery(types.GET_EVERY_ASEGURADOCERTIFICADOPOLIZA, getAseguradoCertificadoPolizaSaga);
  yield takeEvery(types.POST_EVERY_ASEGURADOCERTIFICADOPOLIZA, postAseguradoCertificadoPolizaSaga);
  yield takeEvery(types.PUT_EVERY_ASEGURADOCERTIFICADOPOLIZA, putAseguradoCertificadoPolizaSaga);
  yield takeEvery(types.DELETE_EVERY_ASEGURADOCERTIFICADOPOLIZA, deleteAseguradoCertificadoPolizaSaga);

  yield takeLeading (types.GET_TELSCERTIFICADOPOLIZA, getTelsCertificadoPolizaSaga); 
  yield takeLeading (types.GET_TELCERTIFICADOPOLIZA, getTelCertificadoPolizaSaga);
  yield takeLeading (types.POST_TELCERTIFICADOPOLIZA, postTelCertificadoPolizaSaga);
  yield takeLeading (types.PUT_TELCERTIFICADOPOLIZA, putTelCertificadoPolizaSaga);
  yield takeLeading (types.DELETE_TELCERTIFICADOPOLIZA, deleteTelCertificadoPolizaSaga);

  yield takeEvery(types.GET_EVERY_TELSCERTIFICADOPOLIZA, getTelsCertificadoPolizaSaga);
  yield takeEvery(types.GET_EVERY_TELCERTIFICADOPOLIZA, getTelCertificadoPolizaSaga);
  yield takeEvery(types.POST_EVERY_TELCERTIFICADOPOLIZA, postTelCertificadoPolizaSaga);
  yield takeEvery(types.PUT_EVERY_TELCERTIFICADOPOLIZA, putTelCertificadoPolizaSaga);
  yield takeEvery(types.DELETE_EVERY_TELCERTIFICADOPOLIZA, deleteTelCertificadoPolizaSaga);

  yield takeLeading (types.GET_ARCHIVOSCERTIFICADOPOLIZA, getArchivosCertificadoPolizaSaga); 
  yield takeLeading (types.GET_ARCHIVOCERTIFICADOPOLIZA, getArchivoCertificadoPolizaSaga);
  yield takeLeading (types.POST_ARCHIVOCERTIFICADOPOLIZA, postArchivoCertificadoPolizaSaga);
  yield takeLeading (types.PUT_ARCHIVOCERTIFICADOPOLIZA, putArchivoCertificadoPolizaSaga);
  yield takeLeading (types.DELETE_ARCHIVOCERTIFICADOPOLIZA, deleteArchivoCertificadoPolizaSaga);

  yield takeEvery(types.GET_EVERY_ARCHIVOSCERTIFICADOPOLIZA, getArchivosCertificadoPolizaSaga);
  yield takeEvery(types.GET_EVERY_ARCHIVOCERTIFICADOPOLIZA, getArchivoCertificadoPolizaSaga);
  yield takeEvery(types.POST_EVERY_ARCHIVOCERTIFICADOPOLIZA, postArchivoCertificadoPolizaSaga);
  yield takeEvery(types.PUT_EVERY_ARCHIVOCERTIFICADOPOLIZA, putArchivoCertificadoPolizaSaga);
  yield takeEvery(types.DELETE_EVERY_ARCHIVOCERTIFICADOPOLIZA, deleteArchivoCertificadoPolizaSaga);

  yield takeLeading (types.GET_DPSCERTIFICADOPOLIZA, getDPsCertificadoPolizaSaga); 
  yield takeLeading (types.GET_DPCERTIFICADOPOLIZA, getDPCertificadoPolizaSaga);
  yield takeLeading (types.POST_DPCERTIFICADOPOLIZA, postDPCertificadoPolizaSaga);
  yield takeLeading (types.PUT_DPCERTIFICADOPOLIZA, putDPCertificadoPolizaSaga);
  yield takeLeading (types.DELETE_DPCERTIFICADOPOLIZA, deleteDPCertificadoPolizaSaga);

  yield takeEvery(types.GET_EVERY_DPSCERTIFICADOPOLIZA, getDPsCertificadoPolizaSaga);
  yield takeEvery(types.GET_EVERY_DPCERTIFICADOPOLIZA, getDPCertificadoPolizaSaga);
  yield takeEvery(types.POST_EVERY_DPCERTIFICADOPOLIZA, postDPCertificadoPolizaSaga);
  yield takeEvery(types.PUT_EVERY_DPCERTIFICADOPOLIZA, putDPCertificadoPolizaSaga);
  yield takeEvery(types.DELETE_EVERY_DPCERTIFICADOPOLIZA, deleteDPCertificadoPolizaSaga);

  yield takeLeading (types.GET_PAGOSOXXO, getPagosOxxoSaga); 
  yield takeLeading (types.GET_PAGOOXXO, getPagoOxxoSaga);
  yield takeLeading (types.POST_PAGOOXXO, postPagoOxxoSaga);
  yield takeLeading (types.PUT_PAGOOXXO, putPagoOxxoSaga);
  yield takeLeading (types.DELETE_PAGOOXXO, deletePagoOxxoSaga);

  yield takeEvery(types.GET_EVERY_PAGOSOXXO, getPagosOxxoSaga);
  yield takeEvery(types.GET_EVERY_PAGOOXXO, getPagoOxxoSaga);
  yield takeEvery(types.POST_EVERY_PAGOOXXO, postPagoOxxoSaga);
  yield takeEvery(types.PUT_EVERY_PAGOOXXO, putPagoOxxoSaga);
  yield takeEvery(types.DELETE_EVERY_PAGOOXXO, deletePagoOxxoSaga);

  yield takeLeading (types.GET_REGISTROSPAGOOXXO, getRegistrosPagoOxxoSaga); 
  yield takeLeading (types.GET_REGISTROPAGOOXXO, getRegistroPagoOxxoSaga);
  yield takeLeading (types.POST_REGISTROPAGOOXXO, postRegistroPagoOxxoSaga);
  yield takeLeading (types.PUT_REGISTROPAGOOXXO, putRegistroPagoOxxoSaga);
  yield takeLeading (types.DELETE_REGISTROPAGOOXXO, deleteRegistroPagoOxxoSaga);

  yield takeEvery(types.GET_EVERY_REGISTROSPAGOOXXO, getRegistrosPagoOxxoSaga);
  yield takeEvery(types.GET_EVERY_REGISTROPAGOOXXO, getRegistroPagoOxxoSaga);
  yield takeEvery(types.POST_EVERY_REGISTROPAGOOXXO, postRegistroPagoOxxoSaga);
  yield takeEvery(types.PUT_EVERY_REGISTROPAGOOXXO, putRegistroPagoOxxoSaga);
  yield takeEvery(types.DELETE_EVERY_REGISTROPAGOOXXO, deleteRegistroPagoOxxoSaga);

  yield takeLeading (types.GET_ENDOSOSCERTIFICADOPOLIZA, getEndososCertificadoPolizaSaga); 
  yield takeLeading (types.GET_ENDOSOCERTIFICADOPOLIZA, getEndosoCertificadoPolizaSaga);
  yield takeLeading (types.POST_ENDOSOCERTIFICADOPOLIZA, postEndosoCertificadoPolizaSaga);
  yield takeLeading (types.PUT_ENDOSOCERTIFICADOPOLIZA, putEndosoCertificadoPolizaSaga);
  yield takeLeading (types.DELETE_ENDOSOCERTIFICADOPOLIZA, deleteEndosoCertificadoPolizaSaga);

  yield takeEvery(types.GET_EVERY_ENDOSOSCERTIFICADOPOLIZA, getEndososCertificadoPolizaSaga);
  yield takeEvery(types.GET_EVERY_ENDOSOCERTIFICADOPOLIZA, getEndosoCertificadoPolizaSaga);
  yield takeEvery(types.POST_EVERY_ENDOSOCERTIFICADOPOLIZA, postEndosoCertificadoPolizaSaga);
  yield takeEvery(types.PUT_EVERY_ENDOSOCERTIFICADOPOLIZA, putEndosoCertificadoPolizaSaga);
  yield takeEvery(types.DELETE_EVERY_ENDOSOCERTIFICADOPOLIZA, deleteEndosoCertificadoPolizaSaga);

  yield takeLeading (types.GET_BENEFSCERTIFICADOPOLIZA, getBenefsCertificadoPolizaSaga); 
  yield takeLeading (types.GET_BENEFCERTIFICADOPOLIZA, getBenefCertificadoPolizaSaga);
  yield takeLeading (types.POST_BENEFCERTIFICADOPOLIZA, postBenefCertificadoPolizaSaga);
  yield takeLeading (types.PUT_BENEFCERTIFICADOPOLIZA, putBenefCertificadoPolizaSaga);
  yield takeLeading (types.DELETE_BENEFCERTIFICADOPOLIZA, deleteBenefCertificadoPolizaSaga);

  yield takeEvery(types.GET_EVERY_BENEFSCERTIFICADOPOLIZA, getBenefsCertificadoPolizaSaga);
  yield takeEvery(types.GET_EVERY_BENEFCERTIFICADOPOLIZA, getBenefCertificadoPolizaSaga);
  yield takeEvery(types.POST_EVERY_BENEFCERTIFICADOPOLIZA, postBenefCertificadoPolizaSaga);
  yield takeEvery(types.PUT_EVERY_BENEFCERTIFICADOPOLIZA, putBenefCertificadoPolizaSaga);
  yield takeEvery(types.DELETE_EVERY_BENEFCERTIFICADOPOLIZA, deleteBenefCertificadoPolizaSaga);

  yield takeLeading (types.GET_FACTURASAGENTE, getFacturasAgenteSaga); 
  yield takeLeading (types.GET_FACTURAAGENTE, getFacturaAgenteSaga);
  yield takeLeading (types.POST_FACTURAAGENTE, postFacturaAgenteSaga);
  yield takeLeading (types.PUT_FACTURAAGENTE, putFacturaAgenteSaga);
  yield takeLeading (types.DELETE_FACTURAAGENTE, deleteFacturaAgenteSaga);

  yield takeEvery(types.GET_EVERY_FACTURASAGENTE, getFacturasAgenteSaga);
  yield takeEvery(types.GET_EVERY_FACTURAAGENTE, getFacturaAgenteSaga);
  yield takeEvery(types.POST_EVERY_FACTURAAGENTE, postFacturaAgenteSaga);
  yield takeEvery(types.PUT_EVERY_FACTURAAGENTE, putFacturaAgenteSaga);
  yield takeEvery(types.DELETE_EVERY_FACTURAAGENTE, deleteFacturaAgenteSaga);

  yield takeLeading (types.GET_PRIMASPRODUCTOPOLIZA, getPrimasProductoPolizaSaga); 
  yield takeLeading (types.GET_PRIMAPRODUCTOPOLIZA, getPrimaProductoPolizaSaga);
  yield takeLeading (types.POST_PRIMAPRODUCTOPOLIZA, postPrimaProductoPolizaSaga);
  yield takeLeading (types.PUT_PRIMAPRODUCTOPOLIZA, putPrimaProductoPolizaSaga);
  yield takeLeading (types.DELETE_PRIMAPRODUCTOPOLIZA, deletePrimaProductoPolizaSaga);

  yield takeEvery(types.GET_EVERY_PRIMASPRODUCTOPOLIZA, getPrimasProductoPolizaSaga);
  yield takeEvery(types.GET_EVERY_PRIMAPRODUCTOPOLIZA, getPrimaProductoPolizaSaga);
  yield takeEvery(types.POST_EVERY_PRIMAPRODUCTOPOLIZA, postPrimaProductoPolizaSaga);
  yield takeEvery(types.PUT_EVERY_PRIMAPRODUCTOPOLIZA, putPrimaProductoPolizaSaga);
  yield takeEvery(types.DELETE_EVERY_PRIMAPRODUCTOPOLIZA, deletePrimaProductoPolizaSaga);

  yield takeLeading (types.GET_ASEGURADORAS, getAseguradorasSaga); 
  yield takeLeading (types.GET_ASEGURADORA, getAseguradoraSaga);
  yield takeLeading (types.POST_ASEGURADORA, postAseguradoraSaga);
  yield takeLeading (types.PUT_ASEGURADORA, putAseguradoraSaga);
  yield takeLeading (types.DELETE_ASEGURADORA, deleteAseguradoraSaga);

  yield takeEvery(types.GET_EVERY_ASEGURADORAS, getAseguradorasSaga);
  yield takeEvery(types.GET_EVERY_ASEGURADORA, getAseguradoraSaga);
  yield takeEvery(types.POST_EVERY_ASEGURADORA, postAseguradoraSaga);
  yield takeEvery(types.PUT_EVERY_ASEGURADORA, putAseguradoraSaga);
  yield takeEvery(types.DELETE_EVERY_ASEGURADORA, deleteAseguradoraSaga);

  yield takeLeading (types.GET_PRODUCTOS, getProductosSaga); 
  yield takeLeading (types.GET_PRODUCTO, getProductoSaga);
  yield takeLeading (types.POST_PRODUCTO, postProductoSaga);
  yield takeLeading (types.PUT_PRODUCTO, putProductoSaga);
  yield takeLeading (types.DELETE_PRODUCTO, deleteProductoSaga);

  yield takeEvery(types.GET_EVERY_PRODUCTOS, getProductosSaga);
  yield takeEvery(types.GET_EVERY_PRODUCTO, getProductoSaga);
  yield takeEvery(types.POST_EVERY_PRODUCTO, postProductoSaga);
  yield takeEvery(types.PUT_EVERY_PRODUCTO, putProductoSaga);
  yield takeEvery(types.DELETE_EVERY_PRODUCTO, deleteProductoSaga);

  yield takeLeading (types.GET_AGENTES, getAgentesSaga); 
  yield takeLeading (types.GET_AGENTE, getAgenteSaga);
  yield takeLeading (types.POST_AGENTE, postAgenteSaga);
  yield takeLeading (types.PUT_AGENTE, putAgenteSaga);
  yield takeLeading (types.DELETE_AGENTE, deleteAgenteSaga);

  yield takeEvery(types.GET_EVERY_AGENTES, getAgentesSaga);
  yield takeEvery(types.GET_EVERY_AGENTE, getAgenteSaga);
  yield takeEvery(types.POST_EVERY_AGENTE, postAgenteSaga);
  yield takeEvery(types.PUT_EVERY_AGENTE, putAgenteSaga);
  yield takeEvery(types.DELETE_EVERY_AGENTE, deleteAgenteSaga);

  yield takeLeading (types.GET_DETALLESLISTADEPRECIO, getDetallesListaDePrecioSaga); 
  yield takeLeading (types.GET_DETALLELISTADEPRECIO, getDetalleListaDePrecioSaga);
  yield takeLeading (types.POST_DETALLELISTADEPRECIO, postDetalleListaDePrecioSaga);
  yield takeLeading (types.PUT_DETALLELISTADEPRECIO, putDetalleListaDePrecioSaga);
  yield takeLeading (types.DELETE_DETALLELISTADEPRECIO, deleteDetalleListaDePrecioSaga);

  yield takeEvery(types.GET_EVERY_DETALLESLISTADEPRECIO, getDetallesListaDePrecioSaga);
  yield takeEvery(types.GET_EVERY_DETALLELISTADEPRECIO, getDetalleListaDePrecioSaga);
  yield takeEvery(types.POST_EVERY_DETALLELISTADEPRECIO, postDetalleListaDePrecioSaga);
  yield takeEvery(types.PUT_EVERY_DETALLELISTADEPRECIO, putDetalleListaDePrecioSaga);
  yield takeEvery(types.DELETE_EVERY_DETALLELISTADEPRECIO, deleteDetalleListaDePrecioSaga);

  yield takeLeading (types.GET_ASEGURADOSPRODUCTO, getAseguradosProductoSaga); 
  yield takeLeading (types.GET_ASEGURADOPRODUCTO, getAseguradoProductoSaga);
  yield takeLeading (types.POST_ASEGURADOPRODUCTO, postAseguradoProductoSaga);
  yield takeLeading (types.PUT_ASEGURADOPRODUCTO, putAseguradoProductoSaga);
  yield takeLeading (types.DELETE_ASEGURADOPRODUCTO, deleteAseguradoProductoSaga);

  yield takeEvery(types.GET_EVERY_ASEGURADOSPRODUCTO, getAseguradosProductoSaga);
  yield takeEvery(types.GET_EVERY_ASEGURADOPRODUCTO, getAseguradoProductoSaga);
  yield takeEvery(types.POST_EVERY_ASEGURADOPRODUCTO, postAseguradoProductoSaga);
  yield takeEvery(types.PUT_EVERY_ASEGURADOPRODUCTO, putAseguradoProductoSaga);
  yield takeEvery(types.DELETE_EVERY_ASEGURADOPRODUCTO, deleteAseguradoProductoSaga);

  yield takeLeading (types.GET_LISTASDEPRECIO, getListasDePrecioSaga); 
  yield takeLeading (types.GET_LISTADEPRECIO, getListaDePrecioSaga);
  yield takeLeading (types.POST_LISTADEPRECIO, postListaDePrecioSaga);
  yield takeLeading (types.PUT_LISTADEPRECIO, putListaDePrecioSaga);
  yield takeLeading (types.DELETE_LISTADEPRECIO, deleteListaDePrecioSaga);

  yield takeEvery(types.GET_EVERY_LISTASDEPRECIO, getListasDePrecioSaga);
  yield takeEvery(types.GET_EVERY_LISTADEPRECIO, getListaDePrecioSaga);
  yield takeEvery(types.POST_EVERY_LISTADEPRECIO, postListaDePrecioSaga);
  yield takeEvery(types.PUT_EVERY_LISTADEPRECIO, putListaDePrecioSaga);
  yield takeEvery(types.DELETE_EVERY_LISTADEPRECIO, deleteListaDePrecioSaga);

  yield takeLeading (types.GET_PRIMASLISTADEPRECIO, getPrimasListaDePrecioSaga); 
  yield takeLeading (types.GET_PRIMALISTADEPRECIO, getPrimaListaDePrecioSaga);
  yield takeLeading (types.POST_PRIMALISTADEPRECIO, postPrimaListaDePrecioSaga);
  yield takeLeading (types.PUT_PRIMALISTADEPRECIO, putPrimaListaDePrecioSaga);
  yield takeLeading (types.DELETE_PRIMALISTADEPRECIO, deletePrimaListaDePrecioSaga);

  yield takeEvery(types.GET_EVERY_PRIMASLISTADEPRECIO, getPrimasListaDePrecioSaga);
  yield takeEvery(types.GET_EVERY_PRIMALISTADEPRECIO, getPrimaListaDePrecioSaga);
  yield takeEvery(types.POST_EVERY_PRIMALISTADEPRECIO, postPrimaListaDePrecioSaga);
  yield takeEvery(types.PUT_EVERY_PRIMALISTADEPRECIO, putPrimaListaDePrecioSaga);
  yield takeEvery(types.DELETE_EVERY_PRIMALISTADEPRECIO, deletePrimaListaDePrecioSaga);

  yield takeLeading (types.GET_COBERTURASPRODUCTO, getCoberturasProductoSaga); 
  yield takeLeading (types.GET_COBERTURAPRODUCTO, getCoberturaProductoSaga);
  yield takeLeading (types.POST_COBERTURAPRODUCTO, postCoberturaProductoSaga);
  yield takeLeading (types.PUT_COBERTURAPRODUCTO, putCoberturaProductoSaga);
  yield takeLeading (types.DELETE_COBERTURAPRODUCTO, deleteCoberturaProductoSaga);

  yield takeEvery(types.GET_EVERY_COBERTURASPRODUCTO, getCoberturasProductoSaga);
  yield takeEvery(types.GET_EVERY_COBERTURAPRODUCTO, getCoberturaProductoSaga);
  yield takeEvery(types.POST_EVERY_COBERTURAPRODUCTO, postCoberturaProductoSaga);
  yield takeEvery(types.PUT_EVERY_COBERTURAPRODUCTO, putCoberturaProductoSaga);
  yield takeEvery(types.DELETE_EVERY_COBERTURAPRODUCTO, deleteCoberturaProductoSaga);

  yield takeLeading (types.GET_CLAVESCOMISION, getClavesComisionSaga); 
  yield takeLeading (types.GET_CLAVECOMISION, getClaveComisionSaga);
  yield takeLeading (types.POST_CLAVECOMISION, postClaveComisionSaga);
  yield takeLeading (types.PUT_CLAVECOMISION, putClaveComisionSaga);
  yield takeLeading (types.DELETE_CLAVECOMISION, deleteClaveComisionSaga);

  yield takeEvery(types.GET_EVERY_CLAVESCOMISION, getClavesComisionSaga);
  yield takeEvery(types.GET_EVERY_CLAVECOMISION, getClaveComisionSaga);
  yield takeEvery(types.POST_EVERY_CLAVECOMISION, postClaveComisionSaga);
  yield takeEvery(types.PUT_EVERY_CLAVECOMISION, putClaveComisionSaga);
  yield takeEvery(types.DELETE_EVERY_CLAVECOMISION, deleteClaveComisionSaga);

  yield takeLeading (types.GET_PRODUCTOSCLAVECOMISION, getProductosClaveComisionSaga); 
  yield takeLeading (types.GET_PRODUCTOCLAVECOMISION, getProductoClaveComisionSaga);
  yield takeLeading (types.POST_PRODUCTOCLAVECOMISION, postProductoClaveComisionSaga);
  yield takeLeading (types.PUT_PRODUCTOCLAVECOMISION, putProductoClaveComisionSaga);
  yield takeLeading (types.DELETE_PRODUCTOCLAVECOMISION, deleteProductoClaveComisionSaga);

  yield takeEvery(types.GET_EVERY_PRODUCTOSCLAVECOMISION, getProductosClaveComisionSaga);
  yield takeEvery(types.GET_EVERY_PRODUCTOCLAVECOMISION, getProductoClaveComisionSaga);
  yield takeEvery(types.POST_EVERY_PRODUCTOCLAVECOMISION, postProductoClaveComisionSaga);
  yield takeEvery(types.PUT_EVERY_PRODUCTOCLAVECOMISION, putProductoClaveComisionSaga);
  yield takeEvery(types.DELETE_EVERY_PRODUCTOCLAVECOMISION, deleteProductoClaveComisionSaga);

  yield takeLeading (types.GET_FORMASPAGO, getFormasPagoSaga); 
  yield takeLeading (types.GET_FORMAPAGO, getFormaPagoSaga);
  yield takeLeading (types.POST_FORMAPAGO, postFormaPagoSaga);
  yield takeLeading (types.PUT_FORMAPAGO, putFormaPagoSaga);
  yield takeLeading (types.DELETE_FORMAPAGO, deleteFormaPagoSaga);

  yield takeEvery(types.GET_EVERY_FORMASPAGO, getFormasPagoSaga);
  yield takeEvery(types.GET_EVERY_FORMAPAGO, getFormaPagoSaga);
  yield takeEvery(types.POST_EVERY_FORMAPAGO, postFormaPagoSaga);
  yield takeEvery(types.PUT_EVERY_FORMAPAGO, putFormaPagoSaga);
  yield takeEvery(types.DELETE_EVERY_FORMAPAGO, deleteFormaPagoSaga);

  yield takeLeading (types.GET_PARENTEZCOS, getParentezcosSaga); 
  yield takeLeading (types.GET_PARENTEZCO, getParentezcoSaga);
  yield takeLeading (types.POST_PARENTEZCO, postParentezcoSaga);
  yield takeLeading (types.PUT_PARENTEZCO, putParentezcoSaga);
  yield takeLeading (types.DELETE_PARENTEZCO, deleteParentezcoSaga);

  yield takeEvery(types.GET_EVERY_PARENTEZCOS, getParentezcosSaga);
  yield takeEvery(types.GET_EVERY_PARENTEZCO, getParentezcoSaga);
  yield takeEvery(types.POST_EVERY_PARENTEZCO, postParentezcoSaga);
  yield takeEvery(types.PUT_EVERY_PARENTEZCO, putParentezcoSaga);
  yield takeEvery(types.DELETE_EVERY_PARENTEZCO, deleteParentezcoSaga);

  yield takeLeading (types.GET_ESTATUSPAGOS, getEstatusPagosSaga); 
  yield takeLeading (types.GET_ESTATUSPAGO, getEstatusPagoSaga);
  yield takeLeading (types.POST_ESTATUSPAGO, postEstatusPagoSaga);
  yield takeLeading (types.PUT_ESTATUSPAGO, putEstatusPagoSaga);
  yield takeLeading (types.DELETE_ESTATUSPAGO, deleteEstatusPagoSaga);

  yield takeEvery(types.GET_EVERY_ESTATUSPAGOS, getEstatusPagosSaga);
  yield takeEvery(types.GET_EVERY_ESTATUSPAGO, getEstatusPagoSaga);
  yield takeEvery(types.POST_EVERY_ESTATUSPAGO, postEstatusPagoSaga);
  yield takeEvery(types.PUT_EVERY_ESTATUSPAGO, putEstatusPagoSaga);
  yield takeEvery(types.DELETE_EVERY_ESTATUSPAGO, deleteEstatusPagoSaga);

  yield takeLeading (types.GET_TIPOSPRODUCTO, getTiposProductoSaga); 
  yield takeLeading (types.GET_TIPOPRODUCTO, getTipoProductoSaga);
  yield takeLeading (types.POST_TIPOPRODUCTO, postTipoProductoSaga);
  yield takeLeading (types.PUT_TIPOPRODUCTO, putTipoProductoSaga);
  yield takeLeading (types.DELETE_TIPOPRODUCTO, deleteTipoProductoSaga);

  yield takeEvery(types.GET_EVERY_TIPOSPRODUCTO, getTiposProductoSaga);
  yield takeEvery(types.GET_EVERY_TIPOPRODUCTO, getTipoProductoSaga);
  yield takeEvery(types.POST_EVERY_TIPOPRODUCTO, postTipoProductoSaga);
  yield takeEvery(types.PUT_EVERY_TIPOPRODUCTO, putTipoProductoSaga);
  yield takeEvery(types.DELETE_EVERY_TIPOPRODUCTO, deleteTipoProductoSaga);

  yield takeLeading (types.GET_ORIGENES, getOrigenesSaga); 
  yield takeLeading (types.GET_ORIGEN, getOrigenSaga);
  yield takeLeading (types.POST_ORIGEN, postOrigenSaga);
  yield takeLeading (types.PUT_ORIGEN, putOrigenSaga);
  yield takeLeading (types.DELETE_ORIGEN, deleteOrigenSaga);

  yield takeEvery(types.GET_EVERY_ORIGENES, getOrigenesSaga);
  yield takeEvery(types.GET_EVERY_ORIGEN, getOrigenSaga);
  yield takeEvery(types.POST_EVERY_ORIGEN, postOrigenSaga);
  yield takeEvery(types.PUT_EVERY_ORIGEN, putOrigenSaga);
  yield takeEvery(types.DELETE_EVERY_ORIGEN, deleteOrigenSaga);

  yield takeLeading (types.GET_GENEROS, getGenerosSaga); 
  yield takeLeading (types.GET_GENERO, getGeneroSaga);
  yield takeLeading (types.POST_GENERO, postGeneroSaga);
  yield takeLeading (types.PUT_GENERO, putGeneroSaga);
  yield takeLeading (types.DELETE_GENERO, deleteGeneroSaga);

  yield takeEvery(types.GET_EVERY_GENEROS, getGenerosSaga);
  yield takeEvery(types.GET_EVERY_GENERO, getGeneroSaga);
  yield takeEvery(types.POST_EVERY_GENERO, postGeneroSaga);
  yield takeEvery(types.PUT_EVERY_GENERO, putGeneroSaga);
  yield takeEvery(types.DELETE_EVERY_GENERO, deleteGeneroSaga);

  yield takeLeading (types.GET_ESTATUSCERTIFICADOS, getEstatusCertificadosSaga); 
  yield takeLeading (types.GET_ESTATUSCERTIFICADO, getEstatusCertificadoSaga);
  yield takeLeading (types.POST_ESTATUSCERTIFICADO, postEstatusCertificadoSaga);
  yield takeLeading (types.PUT_ESTATUSCERTIFICADO, putEstatusCertificadoSaga);
  yield takeLeading (types.DELETE_ESTATUSCERTIFICADO, deleteEstatusCertificadoSaga);

  yield takeEvery(types.GET_EVERY_ESTATUSCERTIFICADOS, getEstatusCertificadosSaga);
  yield takeEvery(types.GET_EVERY_ESTATUSCERTIFICADO, getEstatusCertificadoSaga);
  yield takeEvery(types.POST_EVERY_ESTATUSCERTIFICADO, postEstatusCertificadoSaga);
  yield takeEvery(types.PUT_EVERY_ESTATUSCERTIFICADO, putEstatusCertificadoSaga);
  yield takeEvery(types.DELETE_EVERY_ESTATUSCERTIFICADO, deleteEstatusCertificadoSaga);

  yield takeLeading (types.GET_ESTATUSPOLIZAS, getEstatusPolizasSaga); 
  yield takeLeading (types.GET_ESTATUSPOLIZA, getEstatusPolizaSaga);
  yield takeLeading (types.POST_ESTATUSPOLIZA, postEstatusPolizaSaga);
  yield takeLeading (types.PUT_ESTATUSPOLIZA, putEstatusPolizaSaga);
  yield takeLeading (types.DELETE_ESTATUSPOLIZA, deleteEstatusPolizaSaga);

  yield takeEvery(types.GET_EVERY_ESTATUSPOLIZAS, getEstatusPolizasSaga);
  yield takeEvery(types.GET_EVERY_ESTATUSPOLIZA, getEstatusPolizaSaga);
  yield takeEvery(types.POST_EVERY_ESTATUSPOLIZA, postEstatusPolizaSaga);
  yield takeEvery(types.PUT_EVERY_ESTATUSPOLIZA, putEstatusPolizaSaga);
  yield takeEvery(types.DELETE_EVERY_ESTATUSPOLIZA, deleteEstatusPolizaSaga);

  yield takeLeading (types.GET_MEDIOSPAGO, getMediosPagoSaga); 
  yield takeLeading (types.GET_MEDIOPAGO, getMedioPagoSaga);
  yield takeLeading (types.POST_MEDIOPAGO, postMedioPagoSaga);
  yield takeLeading (types.PUT_MEDIOPAGO, putMedioPagoSaga);
  yield takeLeading (types.DELETE_MEDIOPAGO, deleteMedioPagoSaga);

  yield takeEvery(types.GET_EVERY_MEDIOSPAGO, getMediosPagoSaga);
  yield takeEvery(types.GET_EVERY_MEDIOPAGO, getMedioPagoSaga);
  yield takeEvery(types.POST_EVERY_MEDIOPAGO, postMedioPagoSaga);
  yield takeEvery(types.PUT_EVERY_MEDIOPAGO, putMedioPagoSaga);
  yield takeEvery(types.DELETE_EVERY_MEDIOPAGO, deleteMedioPagoSaga);

  yield takeLeading (types.GET_ESTATUSREGISTROSPAGOOXXO, getEstatusRegistrosPagoOxxoSaga); 
  yield takeLeading (types.GET_ESTATUSREGISTROPAGOOXXO, getEstatusRegistroPagoOxxoSaga);
  yield takeLeading (types.POST_ESTATUSREGISTROPAGOOXXO, postEstatusRegistroPagoOxxoSaga);
  yield takeLeading (types.PUT_ESTATUSREGISTROPAGOOXXO, putEstatusRegistroPagoOxxoSaga);
  yield takeLeading (types.DELETE_ESTATUSREGISTROPAGOOXXO, deleteEstatusRegistroPagoOxxoSaga);

  yield takeEvery(types.GET_EVERY_ESTATUSREGISTROSPAGOOXXO, getEstatusRegistrosPagoOxxoSaga);
  yield takeEvery(types.GET_EVERY_ESTATUSREGISTROPAGOOXXO, getEstatusRegistroPagoOxxoSaga);
  yield takeEvery(types.POST_EVERY_ESTATUSREGISTROPAGOOXXO, postEstatusRegistroPagoOxxoSaga);
  yield takeEvery(types.PUT_EVERY_ESTATUSREGISTROPAGOOXXO, putEstatusRegistroPagoOxxoSaga);
  yield takeEvery(types.DELETE_EVERY_ESTATUSREGISTROPAGOOXXO, deleteEstatusRegistroPagoOxxoSaga);

  yield takeLeading (types.GET_MOTIVOSCANCELACION, getMotivosCancelacionSaga); 
  yield takeLeading (types.GET_MOTIVOCANCELACION, getMotivoCancelacionSaga);
  yield takeLeading (types.POST_MOTIVOCANCELACION, postMotivoCancelacionSaga);
  yield takeLeading (types.PUT_MOTIVOCANCELACION, putMotivoCancelacionSaga);
  yield takeLeading (types.DELETE_MOTIVOCANCELACION, deleteMotivoCancelacionSaga);

  yield takeEvery(types.GET_EVERY_MOTIVOSCANCELACION, getMotivosCancelacionSaga);
  yield takeEvery(types.GET_EVERY_MOTIVOCANCELACION, getMotivoCancelacionSaga);
  yield takeEvery(types.POST_EVERY_MOTIVOCANCELACION, postMotivoCancelacionSaga);
  yield takeEvery(types.PUT_EVERY_MOTIVOCANCELACION, putMotivoCancelacionSaga);
  yield takeEvery(types.DELETE_EVERY_MOTIVOCANCELACION, deleteMotivoCancelacionSaga);

  yield takeLeading (types.GET_REGIMENESFISCALES, getRegimenesFiscalesSaga); 
  yield takeLeading (types.GET_REGIMENFISCAL, getRegimenFiscalSaga);
  yield takeLeading (types.POST_REGIMENFISCAL, postRegimenFiscalSaga);
  yield takeLeading (types.PUT_REGIMENFISCAL, putRegimenFiscalSaga);
  yield takeLeading (types.DELETE_REGIMENFISCAL, deleteRegimenFiscalSaga);

  yield takeEvery(types.GET_EVERY_REGIMENESFISCALES, getRegimenesFiscalesSaga);
  yield takeEvery(types.GET_EVERY_REGIMENFISCAL, getRegimenFiscalSaga);
  yield takeEvery(types.POST_EVERY_REGIMENFISCAL, postRegimenFiscalSaga);
  yield takeEvery(types.PUT_EVERY_REGIMENFISCAL, putRegimenFiscalSaga);
  yield takeEvery(types.DELETE_EVERY_REGIMENFISCAL, deleteRegimenFiscalSaga);

  yield takeLeading (types.GET_USUARIOS, getUsuariosSaga); 
  yield takeLeading (types.GET_USUARIO, getUsuarioSaga);
  yield takeLeading (types.POST_USUARIO, postUsuarioSaga);
  yield takeLeading (types.PUT_USUARIO, putUsuarioSaga);
  yield takeLeading (types.DELETE_USUARIO, deleteUsuarioSaga);

  yield takeEvery(types.GET_EVERY_USUARIOS, getUsuariosSaga);
  yield takeEvery(types.GET_EVERY_USUARIO, getUsuarioSaga);
  yield takeEvery(types.POST_EVERY_USUARIO, postUsuarioSaga);
  yield takeEvery(types.PUT_EVERY_USUARIO, putUsuarioSaga);
  yield takeEvery(types.DELETE_EVERY_USUARIO, deleteUsuarioSaga);

  yield takeLeading (types.GET_ACTUALIZACIONES, getActualizacionesSaga); 
  yield takeLeading (types.GET_ACTUALIZACION, getActualizacionSaga);
  yield takeLeading (types.POST_ACTUALIZACION, postActualizacionSaga);
  yield takeLeading (types.PUT_ACTUALIZACION, putActualizacionSaga);
  yield takeLeading (types.DELETE_ACTUALIZACION, deleteActualizacionSaga);

  yield takeEvery(types.GET_EVERY_ACTUALIZACIONES, getActualizacionesSaga);
  yield takeEvery(types.GET_EVERY_ACTUALIZACION, getActualizacionSaga);
  yield takeEvery(types.POST_EVERY_ACTUALIZACION, postActualizacionSaga);
  yield takeEvery(types.PUT_EVERY_ACTUALIZACION, putActualizacionSaga);
  yield takeEvery(types.DELETE_EVERY_ACTUALIZACION, deleteActualizacionSaga);

  yield takeLeading (types.GET_OPERACIONES, getOperacionesSaga); 
  yield takeLeading (types.GET_OPERACION, getOperacionSaga);
  yield takeLeading (types.POST_OPERACION, postOperacionSaga);
  yield takeLeading (types.PUT_OPERACION, putOperacionSaga);
  yield takeLeading (types.DELETE_OPERACION, deleteOperacionSaga);

  yield takeEvery(types.GET_EVERY_OPERACIONES, getOperacionesSaga);
  yield takeEvery(types.GET_EVERY_OPERACION, getOperacionSaga);
  yield takeEvery(types.POST_EVERY_OPERACION, postOperacionSaga);
  yield takeEvery(types.PUT_EVERY_OPERACION, putOperacionSaga);
  yield takeEvery(types.DELETE_EVERY_OPERACION, deleteOperacionSaga);

  yield takeLeading (types.GET_RUTAS, getRutasSaga); 
  yield takeLeading (types.GET_RUTA, getRutaSaga);
  yield takeLeading (types.POST_RUTA, postRutaSaga);
  yield takeLeading (types.PUT_RUTA, putRutaSaga);
  yield takeLeading (types.DELETE_RUTA, deleteRutaSaga);

  yield takeEvery(types.GET_EVERY_RUTAS, getRutasSaga);
  yield takeEvery(types.GET_EVERY_RUTA, getRutaSaga);
  yield takeEvery(types.POST_EVERY_RUTA, postRutaSaga);
  yield takeEvery(types.PUT_EVERY_RUTA, putRutaSaga);
  yield takeEvery(types.DELETE_EVERY_RUTA, deleteRutaSaga);

  yield takeLeading (types.GET_PERFILES, getPerfilesSaga); 
  yield takeLeading (types.GET_PERFIL, getPerfilSaga);
  yield takeLeading (types.POST_PERFIL, postPerfilSaga);
  yield takeLeading (types.PUT_PERFIL, putPerfilSaga);
  yield takeLeading (types.DELETE_PERFIL, deletePerfilSaga);

  yield takeEvery(types.GET_EVERY_PERFILES, getPerfilesSaga);
  yield takeEvery(types.GET_EVERY_PERFIL, getPerfilSaga);
  yield takeEvery(types.POST_EVERY_PERFIL, postPerfilSaga);
  yield takeEvery(types.PUT_EVERY_PERFIL, putPerfilSaga);
  yield takeEvery(types.DELETE_EVERY_PERFIL, deletePerfilSaga);

  yield takeLeading (types.GET_RUTASROL, getRutasRolSaga); 
  yield takeLeading (types.GET_RUTAROL, getRutaRolSaga);
  yield takeLeading (types.POST_RUTAROL, postRutaRolSaga);
  yield takeLeading (types.PUT_RUTAROL, putRutaRolSaga);
  yield takeLeading (types.DELETE_RUTAROL, deleteRutaRolSaga);

  yield takeEvery(types.GET_EVERY_RUTASROL, getRutasRolSaga);
  yield takeEvery(types.GET_EVERY_RUTAROL, getRutaRolSaga);
  yield takeEvery(types.POST_EVERY_RUTAROL, postRutaRolSaga);
  yield takeEvery(types.PUT_EVERY_RUTAROL, putRutaRolSaga);
  yield takeEvery(types.DELETE_EVERY_RUTAROL, deleteRutaRolSaga);

  yield takeLeading (types.GET_ROLES, getRolesSaga); 
  yield takeLeading (types.GET_ROL, getRolSaga);
  yield takeLeading (types.POST_ROL, postRolSaga);
  yield takeLeading (types.PUT_ROL, putRolSaga);
  yield takeLeading (types.DELETE_ROL, deleteRolSaga);

  yield takeEvery(types.GET_EVERY_ROLES, getRolesSaga);
  yield takeEvery(types.GET_EVERY_ROL, getRolSaga);
  yield takeEvery(types.POST_EVERY_ROL, postRolSaga);
  yield takeEvery(types.PUT_EVERY_ROL, putRolSaga);
  yield takeEvery(types.DELETE_EVERY_ROL, deleteRolSaga);

  yield takeLeading (types.GET_ROLESPERFIL, getRolesPerfilSaga); 
  yield takeLeading (types.GET_ROLPERFIL, getRolPerfilSaga);
  yield takeLeading (types.POST_ROLPERFIL, postRolPerfilSaga);
  yield takeLeading (types.PUT_ROLPERFIL, putRolPerfilSaga);
  yield takeLeading (types.DELETE_ROLPERFIL, deleteRolPerfilSaga);

  yield takeEvery(types.GET_EVERY_ROLESPERFIL, getRolesPerfilSaga);
  yield takeEvery(types.GET_EVERY_ROLPERFIL, getRolPerfilSaga);
  yield takeEvery(types.POST_EVERY_ROLPERFIL, postRolPerfilSaga);
  yield takeEvery(types.PUT_EVERY_ROLPERFIL, putRolPerfilSaga);
  yield takeEvery(types.DELETE_EVERY_ROLPERFIL, deleteRolPerfilSaga);

}

